import React, { Component } from 'react';
import Page from './page';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
//import clickMenuLateral from '../../redux/actions/actionbar/clickMenuLateral'
import { getCurrentUser, getCanPermisos } from '../../services/auth'
import CircularProgress from '@material-ui/core/CircularProgress';


class IDrawerContratos extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            openClose: true,
            rol: null,
            permisos: {
                verContrato: false,
                verContratoTerminados: true,
                agregarContrato: false,
                editarContrato: false,
                verMandante: false,
                agregarMandante: false,
                editarMandante: false,
                verGerencia: false,
                agregarGerencia: false,
                editarGerencia: false,
                verResponsable: false,
                agregarResponsable: false,
                editarResponsable: true,
            }
        };
    }


    componentDidMount() {
        this._isMounted = true;

        this._asyncCurrentUser = getCurrentUser().then(
            async  user => {
                if (user.claims.rol) {
                    // console.log(user.claims.accesos.moduloProyectos.rol);
                    var permisosDB = await getCanPermisos(user.claims.rol.rol).then();
                    // console.log(permisosDB);
                    // console.log(user.claims.rol)
                    if (this._isMounted) {
                        this.setState({ rol: user.claims.rol });
                        this.setState({ permisos: permisosDB });
                        // setTimeout(() => {



                        // }, 1000)
                    }
                }
            }
        );
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        var toggle = this.state.openClose ? false : true;
        const { rol, permisos } = this.state;
        if (this.state.rol === null) {
            return (
                <CircularProgress style={{ paddingTop: 15 }} />
            );
        } else {
            return (
                <Page
                    rol={rol}
                    openClose={toggle}
                    permisos={permisos}
                />
            );
        }

    }
}



function mapStateToProps(state) {
    return {
    }
}
const mapDispatchToProps = {
    //clickMenuLateral
};

// conectar un componente con redux 
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(IDrawerContratos)
);
